import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import onlineListTW from '@/assets/img/onlineList-zhtw.png';
import onlineListEn from '@/assets/img/onlineList-en.png';
import onlineListCn from '@/assets/img/onlineList-cn.png';
import onlineListVideoTw from '@/assets/video/onlineList-tw.mp4';
import onlineListVideoEn from '@/assets/video/onlineList-en.mp4';
import onlineListVideoCn from '@/assets/video/onlineList-cn.mp4';
import onlineListExplainTw from '@/assets/img/onlineListExplain-tw.png';
import onlineListExplainEn from '@/assets/img/onlineListExplain-en.png';
import onlineListExplainCn from '@/assets/img/onlineListExplain-cn.png';
import infoEditTw from '@/assets/img/infoEdit-zhtw.png';
import infoEditEn from '@/assets/img/infoEdit-en.png';
import infoEditCn from '@/assets/img/infoEdit-cn.png';
import passwordEditTw from '@/assets/img/passwordEdit-zhtw.png';
import passwordEditEn from '@/assets/img/passwordEdit-en.png';
import passwordEditCn from '@/assets/img/passwordEdit-cn.png';

/**
 * 切換廠區
 * @param {*} i18n
 */
export function callHelpSwitchFactory(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#selectFactory',
        popover: {
          title: i18n.$t('Layout').switchFactory,
          description: i18n.$t('Layout').switchFactoryDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 切換語系
 * @param {*} i18n
 */
export function callHelpSwitchLanguage(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#selectLanguage',
        popover: {
          title: i18n.$t('Layout').switchLanguage,
          description: i18n.$t('Layout').switchLanguageExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫已登入的在線列表在哪裡？
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpWhereOnlineListAfterLoginSuccess(i18n, store) {
  let videoSource = null;
  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      videoSource = onlineListVideoTw;
      imgSource = onlineListExplainTw;
      break;

    case 'en':
      videoSource = onlineListVideoEn;
      imgSource = onlineListExplainEn;
      break;

    case 'cn':
      videoSource = onlineListVideoCn;
      imgSource = onlineListExplainCn;
      break;

    default:
      videoSource = onlineListVideoTw;
      imgSource = onlineListExplainTw;
      break;
  }

  const videoDescription = `
          <p>${i18n.$t('Layout').onlineListExplain}</p>
          <video width="800" controls>
            <source src='${videoSource}' type="video/mp4">
          </video>
          `;

  const imgDescription = `<img src=${imgSource} width="800"/>`;

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#menu',
        popover: {
          title: i18n.$t('OnlineStatus').where_online_list,
          description: videoDescription,
          popoverClass: 'videoExplain',
        },
      },
      {
        element: '#menu',
        popover: {
          title: i18n.$t('OnlineStatus').online_list,
          description: imgDescription,
          popoverClass: 'imgExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫登入檢查的在線列表
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpOnlineListWhenLoginCheck(i18n, store) {
  const driverObj = driver({
    popoverClass: 'classOnlineList',
  });

  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = onlineListTW;
      break;

    case 'en':
      imgSource = onlineListEn;
      break;

    case 'cn':
      imgSource = onlineListCn;
      break;

    default:
      imgSource = onlineListTW;
      break;
  }

  const htmlContext = `
  <img src='${imgSource}' width="650"></img>
  <p>${i18n.$t('Layout').onlineListKeyPoints}</p>
  <p>1.${i18n.$t('Layout').onlineListKick}</p>
  <p>2.${i18n.$t('Layout').onlineListNoAuthority}</p>
  `;

  driverObj.highlight({
    popover: {
      title: i18n.$t('Layout').onlineListTitle,
      description: htmlContext,
    },
  });
}

/**
 * 打開個人資料
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpViewProfile(i18n, store) {
  let imgSource = null;
  let imgPwdSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = infoEditTw;
      imgPwdSource = passwordEditTw;
      break;

    case 'en':
      imgSource = infoEditEn;
      imgPwdSource = passwordEditEn;
      break;

    case 'cn':
      imgSource = infoEditCn;
      imgPwdSource = passwordEditCn;
      break;

    default:
      imgSource = infoEditTw;
      imgPwdSource = passwordEditTw;
      break;
  }

  const infoEditHtmlContext = `
  <img src='${imgSource}' width="410"></img>
  <p>${i18n.$t('Layout').infoEditExplain}</p>
  `;

  const pwdHtmlContext = `
  <img src='${imgPwdSource}' width="450"></img>
  <p>${i18n.$t('Layout').passwordEditExplain}</p>
  `;

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#menu',
        popover: {
          title: i18n.$t('Layout').profile,
          description: i18n.$t('Layout').ViewProfile,
        },
      },
      {
        element: '#menu',
        popover: {
          title: i18n.$t('Layout').userInfoInfoEdit,
          description: infoEditHtmlContext,
          popoverClass: 'profileImgExplain',
        },
      },
      {
        element: '#menu',
        popover: {
          title: i18n.$t('Layout').userInfoPasswordEdit,
          description: pwdHtmlContext,
          popoverClass: 'profileImgExplain',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 登出
 * @param {*} i18n
 */
export function callHelpLogout(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#menu',
        popover: {
          title: i18n.$t('Layout').logout,
          description: i18n.$t('Layout').LogoutExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}
